import React from 'react'

// Components
import Col from 'ui/Col'
import Row from 'ui/Row'
import Text from 'ui/Text'
import EcwtTracker from 'components/Ecwt/EcwtTracker/EcwtTracker'
import Container from 'ui/Container'
import Header from 'ui/Header'
import Navbar from 'ui/Navbar'

export default function PageEcwtList() {
  return (
    <>
      <Header />
      <Navbar />
      <Container>
        <Row>
          <Col sm={12} md={7}>
            <Text size={30} bold color="#000000" paddingTop={30}>
              e-Creditable Withholding Tax
            </Text>
            <Text size={16} color="#000000">
              Below are your electronic creditable withholding tax forms (BIR
              2307). You may view, download or raise your concerns should you
              have any
            </Text>
          </Col>
        </Row>

        <div>
          <Row>
            <Col sm={12} md={10}>
              <EcwtTracker></EcwtTracker>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  )
}
